import { Box, Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";

import AddDetailsProfileBoxForm from "./AddDetailsProfileBoxForm";
import { ButtonLoader } from "../../../../../inputs.styled";
import { useFormikContext } from "formik";
import { colors } from "../../../../../../utils";

const InnerForm = ({ onClose, apiLoading }) => {
  const { handleSubmit, submitCount, isSubmitting, values } =
    useFormikContext();

  const [showADPError, setShowADPError] = useState(false);

  useEffect(() => {
    if (submitCount > 0 && !isSubmitting) {
      setShowADPError(true);
    }
  }, [submitCount, isSubmitting, values]);

  const renderFormContent = () => {
    return <AddDetailsProfileBoxForm showError={showADPError} />;
  };

  return (
    <Box
      sx={{
        pr: "5px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: colors.white,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexShrink: 0, // Prevent header from shrinking
        }}
      >
        <Typography
          sx={{
            color: "#0F0F0F",
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "20px",
            fontFamily: "DM Sans",
          }}
        >
          My Profile
        </Typography>
      </Box>

      {/* Content section - will scroll */}
      <Box
        sx={{
          flex: "1 1 auto", // Allow growing and shrinking
          overflowY: "auto", // Enable vertical scrolling
          overflowX: "hidden", // Prevent horizontal scrolling
          minHeight: 0, // Critical for scrolling to work with flex
          mx: 2,
          mb: 2,
          // Debug outline to see the container boundaries
          // outline: "1px dashed blue",
        }}
      >
        {renderFormContent()}
      </Box>

      {/* Footer section - will stay at bottom */}
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: colors.white,
          zIndex: 2,
          p: 3,
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          borderTop: "2px solid #BBBBBB",
          mt: "auto", // This pushes it to the bottom of the flex container
          flexShrink: 0, // Prevent footer from shrinking
        }}
      >
        <Button
          sx={{
            color: "#495057",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "500",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          sx={{
            color: "white",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "500",
            background: "#9B5AF8",
            "&:hover": {
              background: "#9B5AF885",
            },
          }}
          disabled={false}
        >
          {apiLoading && <ButtonLoader />} {"Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default InnerForm;
